import { Anchor, Breadcrumbs } from '@mantine/core';
import { invokeEvent } from 'shared-base';
import { Json } from '../../types';
import { Chip, Wrapper } from './BreadCrumbs.style';

export type BreadCrumbsProps = {
  items: Json[];
  separator?: string;
  value: string;
  badge?: string;
};

export function BreadCrumbs(props: BreadCrumbsProps) {
  const { items, separator, value, badge } = props;

  function onClick(item: Json) {
    invokeEvent('nav', { path: item.path });
  }

  function renderItem(item: Json, index: number) {
    const styles = {
      root: { color: item.id === value ? '#FF29A8' : '' },
    };

    return (
      <Anchor key={item.id + index} onClick={() => onClick(item)} styles={styles}>
        {item.title}
      </Anchor>
    );
  }

  function renderItems() {
    return items.map((item: Json, index) => renderItem(item, index));
  }

  return (
    <Wrapper className='BreadCrumbs-wrapper' data-testid='BreadCrumbs-wrapper'>
      <Breadcrumbs separator={separator}>{renderItems()}</Breadcrumbs>
      {badge && <Chip>({badge})</Chip>}
    </Wrapper>
  );
}

export default BreadCrumbs;
